import { Fragment, useState, useEffect } from "react"

const HeaderMiddleLevel = ({ middleLevel, type, chaild }) => {
    // const [menuCollapsed, setMenuCollapsed] = useState(false)
    const [check, setCheck] = useState(false)


    // useEffect(() => {
    //   if (window.localStorage.getItem("menuCollapsed")) {
    //     setMenuCollapsed(JSON.parse(window.localStorage.getItem("menuCollapsed")))
    //   }
    // }, [window.localStorage.getItem("menuCollapsed")])

    useEffect(() => {
        setCheck(/<sup>.*<\/sup>/.test(middleLevel))
    }, [])
    const sanitizeId = (value) => {
        return value.replace(/[^a-zA-Z0-9-_]/g, '_')
    }
    const sanitizedId = sanitizeId(`cn${middleLevel}`)
    return (
        <div className="middlelevel_header d-flex justify-content-end">
            {middleLevel && (
                <Fragment>
                    {type === 'aff' ? check === false ? (
                        <div id={sanitizedId} className="truncate-text">
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                                <div>Parent Agent : {middleLevel}</div>
                                <div>Affiliate Agent : {chaild}</div>
                            </div>
                        </div>
                    ) : (
                        <div
                            id={sanitizedId}
                            className="truncate-text"
                            dangerouslySetInnerHTML={{ __html: middleLevel }}
                        ></div>
                    ) : check === false ? (
                        <div id={sanitizedId} className="truncate-text">
                            {middleLevel}
                        </div>
                    ) : (
                        <div
                            id={sanitizedId}
                            className="truncate-text"
                            dangerouslySetInnerHTML={{ __html: middleLevel }}
                        ></div>
                    )}
                    {/* <UncontrolledTooltip placement='bottom' target={sanitizedId}>
            {check === false && middleLevel}
            {check === true && <p dangerouslySetInnerHTML={{ __html: middleLevel }}></p>}
          </UncontrolledTooltip> */}
                </Fragment>
            )}
        </div>
    )
}


export default HeaderMiddleLevel